import axios from "axios";

export const state = {
    roles: [],
    staff_positions: [],
    staff_shifts: [],
    staff_saving: false,
    clinicstaffs: [],
    staff: {},
    shift: [],
    active_users: 1,
};
export const getters = {
    clinic_staff: state => state.clinicstaffs.data,
    user_roles: state => state.roles.data,
    activeUsers: state => state.active_users,
    staff_profile: state => state.staff.data,
    StaffPositions: state => state.staff_positions.data,
    StaffShifts: state => state.staff_shifts.data,
    Shift: state => state.shift,
    StaffSaveStatus: state => state.staff_saving,
    StaffAudits: state => state.staff.data.useraccount ? state.staff.data.useraccount.audits : [],
};


export const mutations = {
    SET_STAFFS(state, newValue) {
        state.clinicstaffs = newValue
    },
    SET_SHIFT(state, newValue) {
        state.shift = newValue
    },
    SET_STAFF_PROFILE(state, newValue) {
        state.staff = newValue
    },
    SET_STAFF_POSITIONS(state, newValue) {
        state.staff_positions = newValue
    },
    SET_STAFF_SHIFTS(state, newValue) {
        state.staff_shifts = newValue
    },
    SET_STAFF_STATUS(state, newValue) {
        state.staff_saving = newValue
    },
    SET_ROLES(state, newValue) {
        state.roles = newValue
    },
    SET_ACTIVE_USERS(state, newValue) {
        state.active_users = newValue
    },
    PREVIEW_PROFILE(state) {
        state.staff = {
            "data": {
                "id": "",
                "staffName": "",
                "staffContact": "",
                "staffEmail": "",
                "staffImage": "",
                "staffAddress": "",
                "staffGender": "",
                "type": "",
                "loggedin": "",
                "DOB": "",
                "position": {
                    "id": "",
                    "position_name": "",
                    "status": "",
                    "clinic_id": "",
                    "added_by": "",
                    "created_at": "",
                    "updated_at": ""
                },
                "branch": {
                    "id": "",
                    "name": "",
                    "address": "",
                    "clinic_id": "",
                    "status": "",
                    "added_by": "",
                    "created_at": "",
                    "updated_at": ""
                },
                "clinic": {
                    "id": "",
                    "clinicName": "",
                    "clinicStamp": "",
                    "clinicAddress": "",
                    "clinicContact": "",
                    "hasLab": "",
                    "clinicMail": "",
                    "hasBranch": "",
                    "status": "",
                    "isSuspended": "",
                    "clinicLogo": "",
                    "package": {
                        "id": "",
                        "pack_name": "",
                        "users": "",
                        "added_by": "",
                        "status": "",
                        "updated_at": "",
                        "created_at": ""
                    },
                    "totalusers": "",
                    "dateCreated": "",
                    "dateUpdated": ""
                },
                "useraccount": "",
                "dateCreated": "",
                "dateUpdated": ""
            }
        }
    },

};
export const actions = {
    addStaffPosition({ commit, dispatch }, payload) {
        // console.log(payload);
        commit('SET_STAFF_STATUS', true);
        axios.post('positions', payload).then(() => {
            dispatch('fetchStaffPositions');
            let message = { 'msg': "Staff Position added successfully" }
                // DISPATCH MESSAGE MODULE
            dispatch('notification/success', message, { root: true })
            commit('SET_STAFF_STATUS', false);
        }).catch(() => {
            commit('SET_STAFF_STATUS', false)
            let message = { 'msg': "Error Adding Staff Position" }
            dispatch('notification/error', message, { root: true })
        })
    },
    // Edit Staff Position
    editStaffPosition({ commit, dispatch }, payload) {
        commit('SET_STAFF_STATUS', true);
        axios.put(`positions/${payload.id}`, payload).then(() => {
            dispatch('fetchStaffPositions');
            let message = { 'msg': "Staff Position updated successfully" }
                // DISPATCH MESSAGE MODULE
            dispatch('notification/success', message, { root: true })
            commit('SET_STAFF_STATUS', false);
        }).catch(() => {
            commit('SET_STAFF_STATUS', false)
            let message = { 'msg': "Error updating Staff Position" }
            dispatch('notification/error', message, { root: true })
        })
    },
    // Delete Staff Position
    deleteStaffPosition({ commit, dispatch }, payload) {
        // console.log(payload);
        commit('SET_STAFF_STATUS', true);
        axios.delete(`positions/${payload.id}`).then(() => {
            dispatch('fetchStaffPositions');
            let message = { 'msg': "Staff Position deleted successfully" }
                // DISPATCH MESSAGE MODULE
            dispatch('notification/success', message, { root: true })
            commit('SET_STAFF_STATUS', false);
        }).catch(() => {
            commit('SET_STAFF_STATUS', false)
            let message = { 'msg': "Error deleting Staff Position" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // add staff
    addClinicStaff({ commit, dispatch }, payload) {
        // console.log(payload);
        commit('SET_STAFF_STATUS', true);
        axios.post('staffs', payload).then(() => {
            dispatch('fetchClinicStaff');
            let message = { 'msg': "Staff Member added successfully" }
                // DISPATCH MESSAGE MODULE
            dispatch('notification/success', message, { root: true })
            commit('SET_STAFF_STATUS', false);
        }).catch(() => {
            commit('SET_STAFF_STATUS', false)
            let message = { 'msg': "Error Adding Staff Member" }
            dispatch('notification/error', message, { root: true })
        })
    },
    // Edit Staff Position
    editStaff({ commit, dispatch }, payload) {
        commit('SET_STAFF_STATUS', true);
        axios.put(`staffs/${payload.id}`, payload).then(() => {
            dispatch('fetchStaffProfile', payload.id);
            let message = { 'msg': "Staff Member updated successfully" }
                // DISPATCH MESSAGE MODULE
            dispatch('notification/success', message, { root: true })
            commit('SET_STAFF_STATUS', false);
        }).catch(() => {
            commit('SET_STAFF_STATUS', false)
            let message = { 'msg': "Error updating Staff Details" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Edit Staff Position
    enrolStaff({ commit, dispatch }, payload) {
        axios.post(`enroll_user`, payload).then(() => {
            dispatch('fetchStaffProfile', payload.staff_id);
            let message = { 'msg': "Staff Member updated successfully" }
                // DISPATCH MESSAGE MODULE
            dispatch('notification/success', message, { root: true })
            commit('SET_STAFF_STATUS', false);
        }).catch(() => {
            commit('SET_STAFF_STATUS', false)
            let message = { 'msg': "Error updating Staff Details" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Delete Staff Position
    deleteClinicStaff({ commit, dispatch }, payload) {
        // console.log(payload);
        commit('SET_STAFF_STATUS', true);
        axios.delete(`staffs/${payload.id}`).then(() => {
            dispatch('fetchClinicStaff');
            let message = { 'msg': "Staff Member deleted successfully" }
                // DISPATCH MESSAGE MODULE
            dispatch('notification/success', message, { root: true })
            commit('SET_STAFF_STATUS', false);
        }).catch(() => {
            commit('SET_STAFF_STATUS', false)
            let message = { 'msg': "Error deleting Staff Member" }
            dispatch('notification/error', message, { root: true })
        })
    },

    fetchClinicStaff({ commit }) {
        axios.get('staffs').then(staff => {
            commit('SET_STAFFS', staff.data)
        })
    },
    fetchActiveUsers({ commit }) {
        axios.get('active_users').then(users => {
            commit('SET_ACTIVE_USERS', users.data)
        })
    },
    fetchStaffProfile({ commit }, staff) {
        commit('PREVIEW_PROFILE')
        axios.get(`staffs/${staff}`).then(staff => {
            commit('SET_STAFF_PROFILE', staff.data)
        })
    },
    fetchStaffPositions({ commit }) {
        axios.get('positions').then(position => {
            commit('SET_STAFF_POSITIONS', position.data)
        })
    },
    fetchStaffShifts({ commit }) {
        axios.get('shifts').then(shift => {
            commit('SET_STAFF_SHIFTS', shift.data)
        })
    },
    fetchShift({ commit }, shift) {
        axios.get(`shiftx/${shift}`).then(shift => {
            commit('SET_SHIFT', shift.data)
        })
    },
    fetchRoles({ commit }) {
        axios.get('roles').then(role => {
            commit('SET_ROLES', role.data)
        })
    },

};